export function isFeatureNew (feature) {
  if (!feature.newUntil) return false
  return new Date(feature.newUntil).getTime() > Date.now()
}
